import { render, staticRenderFns } from "./Serve.vue?vue&type=template&id=e02235be&scoped=true&"
import script from "./Serve.vue?vue&type=script&lang=js&"
export * from "./Serve.vue?vue&type=script&lang=js&"
import style0 from "./Serve.vue?vue&type=style&index=0&id=e02235be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02235be",
  null
  
)

export default component.exports